module.exports = __webpack_public_path__ + "media/country_flags/gl-8999824c.png";